export const ButtonLabels = {
  Ok: 'Ok',
  Both: 'Both',
  OutcomeOnly: 'Outcome only',
  Move: 'Move',
  SaveAndProceed: 'Save and proceed',
  CloseWithoutSaving: 'Close without saving'
};
